module.exports = __webpack_public_path__ + "static/media/leonard-cotte.3838771f.jpg";